import { Pipe, PipeTransform } from '@angular/core';
import { AmountInput, formatAmount } from 'src/app/utils/currency-format';

export { MISSING_AMOUNT_PLACEHOLDER } from 'src/app/utils/currency-format';
export type { AmountInput } from 'src/app/utils/currency-format';

@Pipe({
  name: 'arsCurrency',
  standalone: false,
})
export class ArsCurrencyPipe implements PipeTransform {
  transform(value: AmountInput): string {
    return formatAmount(value);
  }
}
